export default __webpack_public_path__ + "static/media/telegram.eb6ba643.svg";